import React from 'react';
import TileBoxSkeleton from '../../TileBox/skeleton';

export default function GiftCardsHistorySkeleton() {
  return <TileBoxSkeleton />;
}
